import { Box, HbTooltip, Stack, Text } from '@cdl/heartbeat-react';
import { CustomCircle } from '../../../../shared/components/circle/CustomCircle';

const MAX_USER_TO_DISPLAY = 3;

type Props = {
  users: string[];
};

export const UsersColumn: React.FC<Props> = ({ users }) => {
  const usersToDisplay = users.slice(0, 3);

  const formatName = (fullName: string) => {
    const words = fullName.split(' ');

    const formattedName = words
      .map((word) => word.charAt(0).toUpperCase())
      .join('');
    return formattedName;
  };
  return (
    <HbTooltip
      label={users.map((user) => (
        <Stack>
          <Text>{user}</Text>
        </Stack>
      ))}
      placement='top-start'
    >
      <Box float='left' position='relative'>
        {Array.isArray(users) &&
          usersToDisplay.map((user, index) => (
            <CustomCircle
              key={index}
              left={`${index * 14}px`}
              position='absolute'
              top='-4'
            >
              <Text>{formatName(user)}</Text>
            </CustomCircle>
          ))}
        {users.length > MAX_USER_TO_DISPLAY && (
          <CustomCircle left={`${3 * 14}px`} position='absolute' top='-4'>
            {`+${users.length - 3}`}
          </CustomCircle>
        )}
      </Box>
    </HbTooltip>
  );
};
